import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandlerFn,
	HttpRequest,
	HttpStatusCode
} from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { inject } from "@angular/core";
import { MessageService } from "primeng/api";
import { UserSettingService } from "../../components/user-settings/user-settings.service";
import { environment } from "../../../../environments/environment";
import { ErrorResponse } from "./error-response.model";

export function responseInterceptor(
	request: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
	const messageService = inject(MessageService);
	const userSettingsService = inject(UserSettingService);

	if (
		(request.method === "POST" || request.method === "PUT" || request.method === "DELETE") &&
		request.url.includes(environment.apiDemandUrl) &&
		!request.url.includes("/logs/fe") &&
		!request.url.includes("/reports") &&
		!request.url.includes("/bo-reports")
	) {
		console.info(
			"[ENDPOINT]: " +
				request.url +
				" - " +
				"[METHOD]: " +
				request.method.toUpperCase() +
				" - " +
				"[REQUEST BODY]: " +
				JSON.stringify(request.body)
		);
	}

	return next(request).pipe(
		tap({
			error: error => {
				if (error instanceof HttpErrorResponse) {
					if (!request.url.includes("/logs/fe"))
						console.error(
							"[ENDPOINT]: " +
								request.url +
								" - " +
								"[METHOD]: " +
								request.method.toUpperCase() +
								" - " +
								"[STATUS]: " +
								error.status +
								" - " +
								"[REQUEST BODY]: " +
								JSON.stringify(request.body) +
								" - " +
								"[RESPONSE ERROR]: " +
								JSON.stringify(error.error)
						);

					switch (error.status) {
						case HttpStatusCode.ImATeapot:
							userSettingsService.logout();
							break;
						case HttpStatusCode.Forbidden:
							messageService.add({
								severity: "error",
								summary: "Forbidden",
								detail: "You don't have permission to access this resource."
							});
							break;
						case HttpStatusCode.Conflict:
						case HttpStatusCode.BadRequest:
							(error.error as ErrorResponse)?.messages?.forEach(({ message }) =>
								messageService.add({
									severity: "error",
									summary: "Error",
									detail: message
								})
							);
							break;
					}
				}
			}
		})
	);
}
